import events from '@/components/MultiTab/events'

export default {
  data() {
    return {
      saveType: false, //是否按钮保存
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$route.meta.position = {x:0,y:0}
    if (this.saveType) {
      events.$emit('close', 'customeClose',to)
    }
    next()
  },
  methods: {
    changeSaveType() {
      this.saveType = !this.saveType
    },
  },
}
